import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar-adaptativo',
  templateUrl: './navbar-adaptativo.component.html',
  styleUrl: './navbar-adaptativo.component.css'
})
export class NavbarAdaptativoComponent {
  
  constructor(private router: Router) {

  }
  
  irAHome() {
    this.router.navigate(['']);
  }
}
